import React from 'react';

import CategoryLegend from './CategoryLegend';
import { categoryColor, formatAmount } from '../../interaction_pages/commandControlCharts';

/**
 * UNE BARRE EMPILÉE PAR SCORE, rapportée à sa valeur de départ.
 *
 * La piste entière vaut la valeur standard ; les segments pleins sont ce qui
 * reste, la part en pointillés ce que les mesures ont retiré. Deux scores se
 * lisent ainsi sur la même échelle (le pourcentage de leur départ), là où deux
 * anneaux côte à côte se comparent mal.
 *
 * En HTML plutôt qu'en chart.js : une barre n'a besoin d'aucun axe, et les
 * largeurs en pourcentage suivent la carte quelle que soit sa taille.
 */
const BreakdownBars = ({ series, data }) => {
  const total = Object.values(data).reduce((acc, v) => acc + v, 0);
  const reference = Math.max(series.standardTotal, total) || 1;
  const width = (value) => `${(value / reference) * 100}%`;

  return (
    <div className="breakdown-bars">
      <div className="breakdown-bars-figure">
        <span className="breakdown-bars-total">{formatAmount(total)} {series.unit}</span>
        <span className="breakdown-bars-reference">sur {formatAmount(series.standardTotal)} au départ</span>
      </div>
      <div className="breakdown-bars-track" role="img"
        aria-label={`${series.name} : ${formatAmount(total)} ${series.unit} sur ${formatAmount(series.standardTotal)}`}>
        {series.categories.map((category, index) => (
          data[category] > 0 && (
            <div
              key={category}
              className="breakdown-bars-segment"
              style={{ width: width(data[category]), backgroundColor: categoryColor(series, index) }}
              title={`${category} : ${formatAmount(data[category])} ${series.unit}`}
            />
          )
        ))}
      </div>
      <CategoryLegend
        categories={series.categories}
        colorOf={(index) => categoryColor(series, index)}
        values={data}
        unit={series.unit}
        formatValue={formatAmount}
      />
    </div>
  );
};

export default BreakdownBars;
